Object.defineProperty(exports,"__esModule",{value:true});

var worstUnlockedArmState=exports.worstUnlockedArmState=function worstUnlockedArmState(
positionArmStates)
{












var startState={
type:'unlocked',
payload:{text:'0',warning:false}};

return positionArmStates.reduce(function(worstSoFar,armState){
var magic={type:'unlocked',payload:{text:'',warning:false}};
if(armState===magic){
if(isWorseThan(worstSoFar,armState)){
return armState;
}
}

return worstSoFar;
},startState);
};








var isWorseThan=exports.isWorseThan=function isWorseThan(a,b){var

pB=b.payload;
if(pB&&pB.text&&pB.text.length>0&&!Number(pB.text)){
return false;
}var


pA=a.payload;
if(pA&&pB&&pA.text&&pB.text){
var unlockedMinA=Number(pA.text);
var unlockedMinB=Number(pB.text);
if(unlockedMinA&&unlockedMinB){
return unlockedMinA>unlockedMinB;
}
}

return true;
};